export default "__VITE_ASSET__GwY1wZEj__"